import { defineComponent, computed } from "vue";
import { u as useFixedBarProps, a as useFixedBar } from "../../composables/useFixedBar-e6acac44.mjs";
import { s as setupScroll } from "../../composables/useScroll-41119ddc.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
const _sfc_main = defineComponent({
  name: "VaAppBar",
  props: {
    ...useFixedBarProps,
    ...useComponentPresetProp,
    gradient: { type: Boolean, default: false },
    target: { type: [Object, String], default: "" },
    shadowOnScroll: { type: Boolean, default: false },
    shadowColor: { type: String, default: "" },
    color: { type: String, default: void 0 }
  },
  setup(props) {
    const { scrollRoot, isScrolledDown } = setupScroll(props.fixed, props.target);
    const { fixedBarStyleComputed } = useFixedBar(props, isScrolledDown);
    const { getColor, getGradientBackground, getBoxShadowColor } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    const showShadowComputed = computed(() => isScrolledDown.value ? !!props.shadowOnScroll : false);
    const shadowColorComputed = computed(() => getColor(props.shadowColor, colorComputed.value));
    const computedShadow = computed(() => {
      const shadow = getBoxShadowColor(props.shadowColor ? shadowColorComputed.value : colorComputed.value);
      return showShadowComputed.value ? `var(--va-app-bar-shadow) ${shadow}` : "";
    });
    const computedStyle = computed(() => ({
      ...fixedBarStyleComputed.value,
      background: props.gradient ? getGradientBackground(colorComputed.value) : colorComputed.value,
      boxShadow: computedShadow.value
    }));
    return { scrollRoot, computedStyle };
  }
});
export {
  _sfc_main as _
};

import '../../../VaAppBar.css';
//# sourceMappingURL=VaAppBar.vue_vue_type_script_lang-d507085e.mjs.map
